import * as Needs from "./COVID-19";
export default { Needs };
